import { Box, css } from '@mui/material'

import { SerializedStyles } from '@emotion/react'
import { useMQ } from '../hooks/useMQ'

type Props = {
  centered?: boolean
  fadedBorder?: boolean
  extraStyles?: SerializedStyles
}

export function BlurBox(props: React.PropsWithChildren<Props>) {
  const { isBelowXsSize, isBelow1200 } = useMQ()

  const styles = {
    wrapper: css`
      width: 100%;
      z-index: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    `,
    container: css`
      width: ${isBelow1200 ? '100%' : '1200px'};
      box-sizing: border-box;
      padding: ${isBelowXsSize ? '16px' : '28.5px 54.5px'};
    `,
    blur: css`
      border-radius: 16px;
      border: 1px solid #1b1b1b;
      background: #121212;
      backdrop-filter: blur(50px);
    `,
  }

  return props.centered ? (
    <Box css={styles.wrapper}>
      <Box css={[styles.container, styles.blur, props.extraStyles]}>
        {props.children}
      </Box>
    </Box>
  ) : (
    <Box css={[styles.blur, props.extraStyles]}>{props.children}</Box>
  )
}
